module.exports = __webpack_public_path__ + "static/media/main idea.9155b5cd.mp3";